module.exports = __webpack_public_path__ + "static/st2-9-1db6870a71ff3ec1cd2d4375ebaf0cd7.jpg";